import { createEnumOptions } from '@kinet-open-network/shared/data-access/model';
import {
  IPriceItemWithTotals,
  ITotalItem,
} from '@kinet-open-network/shared/util';

export interface IFlowChangePriceItem extends IPriceItemWithTotals {
  stockItemId: string;
  sortOrder?: number;
  text?: string;
  note?: string;
}

export interface IFlowChangePrices extends ITotalItem {
  customerId: number;
  offerValidTo: Date | null;
  pricesValidFrom: Date;
  status: ChangePriceFlowStatus;
  items: IFlowChangePriceItem[];
  introducingText?: string;
  concludingText?: string;
  contractText?: string;
  representativeOwn?: string | null;
  representativeCustomer?: string | null;
  paymentType?: string | null;
  transportAgreement?: string | null;
  minimumOrder?: string | null;
}

export enum ChangePriceFlowStatus {
  ready = 'ready',
  accepted = 'accepted',
  completed = 'completed',
  rejected = 'rejected',
}

export const changePricesStatusOptions =
  createEnumOptions<ChangePriceFlowStatus>({
    [ChangePriceFlowStatus.ready]: {
      label: 'Cenová ponuka pripravená',
      color: 'none',
    },
    [ChangePriceFlowStatus.accepted]: {
      label: 'Zákazník akceptoval (ceny aplikované)',
      color: 'success',
    },
    [ChangePriceFlowStatus.completed]: { label: 'Ukončené', color: 'primary' },
    [ChangePriceFlowStatus.rejected]: {
      label: 'Neakceptované',
      color: 'danger',
    },
    _default: { label: '-' },
  });

export interface IFlowChangePricesStepData {}
